import buildMatchPatternFn from '../../../_lib/buildMatchPatternFn/index';
import buildMatchFn from '../../../_lib/buildMatchFn/index';

const matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const parseOrdinalNumberPattern = /\d+/i;

const matchEraPatterns = {
  any: /^(miladdan əvvəl|miladi tarix)/i,
};
const parseEraPatterns = {
  any: [/^miladdan əvvəl/i, /^miladi tarix/i],
};

const matchQuarterPatterns = {
  narrow: /^[1234]/i,
  any: /^[1234]-c(i|ü) rüb/i,
};
const parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i],
  abbreviated: [/1-ci rüb/i, /2-ci rüb/i, /3-cü rüb/i, /4-cü rüb/i],
  wide: [/^1-ci rüb/i, /2-ci rüb/i, /3-cü rüb/i, /4-cü rüb/i],
};

const matchMonthPatterns = {
  narrow:
    /^(Yanvar|Fevral|Mart|Aprel|May|İyun|İyul|Avqust|Sentyabr|Oktyabr|Noyabr|Dekabr)/i,
  abbreviated: /^(Yan|Fev|Mart|Apr|May|İyun|İyul|Avq|Sent|Okt|Noy|Dek)/i,
  wide: /^(Yanvar|Fevral|Mart|Aprel|May|İyun|İyul|Avqust|Sentyabr|Oktyabr|Noyabr|Dekabr)/i,
};
const parseMonthPatterns = {
  abbreviated: [
    /^Yan/i,
    /^Fev/i,
    /^Mart/i,
    /^Apr/i,
    /^May/i,
    /^İyun/i,
    /^İyul/i,
    /^Avq/i,
    /^Sent/i,
    /^Okt/i,
    /^Noy/i,
    /^Dek/i,
  ],
  any: [
    /^Yanvar/i,
    /^Fevral/i,
    /^Mart/i,
    /^Aprel/i,
    /^May/i,
    /^İyun/i,
    /^İyul/i,
    /^Avqust/i,
    /^Sentyabr/i,
    /^Oktyabr/i,
    /^Noyabr/i,
    /^Dekabr/i,
  ],
};

const matchDayPatterns = {
  any: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)/i,
  wide: /^(Bazar günü|Bazar ertəsi|Çərşənbə axşamı|Çərşənbə|Cümə axşamı|Cümə|Şənbə)/i,
};
const parseDayPatterns = {
  narrow: [/^c/i, /^m/i, /^b/i, /^t/i, /^s/i, /^h/i, /^m/i],
  short: [/^caw/i, /^mvu/i, /^bin/i, /^tha/i, /^sin/i, /^hla/i, /^mgq/i],
  abbreviated: [/^caw/i, /^mvu/i, /^bin/i, /^tha/i, /^sin/i, /^hla/i, /^mgq/i],
  any: [
    /^Bazar g/i,
    /^Bazar e/i,
    /^Çərşənbə a/i,
    /^Çərşənbə/i,
    /^Cümə a/i,
    /^Cümə/i,
    /^Şənbə/i,
  ],
};

const matchDayPeriodPatterns = {
  narrow: /^(a|p|gecəyarısı|gündüz|səhər|günorta|axşam|gecə)/i,
  abbreviated: /^(AM|PM|gecəyarısı|gündüz|səhər|günorta|axşam|gecə)/i,
  wide: /^(a\.m\.|p\.m\.|gecəyarısı|gündüz|səhər|günorta|axşam|gecə)/i,
};
const parseDayPeriodPatterns = {
  narrow: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^gecəyarısı/i,
    noon: /^gündüz/i,
    morning: /səhər/i,
    afternoon: /günorta/i,
    evening: /axşam/i,
    night: /gecə/i,
  },
  abbreviated: {
    am: /^AM/i,
    pm: /^PM/i,
    midnight: /^gecəyarısı/i,
    noon: /^gündüz/i,
    morning: /səhər/i,
    afternoon: /günorta/i,
    evening: /axşam/i,
    night: /gecə/i,
  },
  any: {
    am: /a\.m\./i,
    pm: /p\.m\./i,
    midnight: /^gecəyarısı/i,
    noon: /^gündüz/i,
    morning: /səhər/i,
    afternoon: /günorta/i,
    evening: /axşam/i,
    night: /gecə/i,
  },
};

const match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    },
  }),

  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any',
  }),

  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    },
  }),

  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any',
  }),

  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any',
  }),

  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any',
  }),
};

export default match;
